import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { find, isEmpty, without } from "lodash";
import { hasChildren, uuid, getOptionCollection } from "./utils";
import { useReactFlow } from "reactflow";

const FailedOption = ({
  chatbotOption,
  setChatbotOption,
  maxCharacters,
  errors,
  addFailedOption,
  removeFailedOption
}) => {
  const { id } = useParams();
  const { getNodes } = useReactFlow();

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = () => {}

  const updateInfo = (name, value) => {
    setChatbotOption({
      ...chatbotOption,
      [name]: value
    });
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { target } = e;
    const { name, value } = target;

    updateInfo(name, value);
  };

  const handleOnlyNumbers = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^\d+$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const toggleFailedOptions = () => {
    const fail_path_active = !chatbotOption.fail_path_active;

    let newArray = getOptionCollection(chatbotOption, 'options_list');
    if (fail_path_active) {
      newArray = addFailedOption(newArray);
    } else {
      newArray = removeFailedOption(newArray);
    }

    setChatbotOption({
      ...chatbotOption,
      fail_path_active,
      options_list: newArray
    });
  };

  const cantToggleFailedOption = () => {
    const failedOption = getOptionCollection(chatbotOption, 'options_list').find((el) => el.option_deleted !== true && el.option_type === "failure");
    const nodes = getNodes();

    return !isEmpty(failedOption) && hasChildren(nodes, failedOption.target);
  };

  return (
    <>
      <div className="col-md-12 mt-20">
        <label className="col-form-label fz-14 mr-10">¿Qué pasa si el usuario se equivoca?</label>
      </div>
      <div className="col-md-12 d-flex flex-row">
        <div className="d-flex align-items-center mr-10">
          <div className="figma-field mb-0">
            <label>Si el usuario no seleccionó una opción válida, contestar con</label>
            <span className="ml-10 error-msg fz-12">{errors.failure_text}</span>
            <input
              value={chatbotOption.failure_text}
              onChange={handleInputChange}
              className="input"
              name="failure_text"
            />
          </div>
        </div>
      </div>
      <div className="col-md-12 d-flex flex-row mt-20">
        <div className="d-flex align-items-center mr-10">
          <div className="tooltip-top">
            <label className="switch">
              <input
                type="checkbox"
                name="fail_path_active"
                checked={chatbotOption.fail_path_active}
                onChange={toggleFailedOptions}
                disabled={cantToggleFailedOption()}
              />
              <span className="slider round" />
            </label>
            { cantToggleFailedOption() && (
              <span className="tooltiptext--black bg-dark tooltiptext tooltip-stats-view">
                No se pueden deshabilitar los intentos fallidos mientras dicho paso tenga hijos
              </span>
            )}
          </div>
        </div>
        <div className="d-flex flex-column fz-14">
          <span className="col-form-label py-0">Ir a otro paso si el usuario no contesta correctamente</span>
          <span className="text-gray-light">Indica cuántos intentos tiene el contacto para contestar incorrectamente antes de salir de este paso.</span>
        </div>
      </div>

      {chatbotOption.fail_path_active && (
        <div className="col-md-12 d-flex flex-row mt-20">
          <div className="d-flex align-items-center mr-10">
            <div className="figma-field mb-0">
              <label>Cantidad de intentos fallidos permitidos</label>
              <span className="ml-10 error-msg fz-12">{errors.max_attempts}</span>
              <input
                value={chatbotOption.max_attempts}
                onChange={handleInputChange}
                className="input"
                name="max_attempts"
                onKeyPress={handleOnlyNumbers}
              />
            </div>
          </div>
        </div>
      )}

      <div className="mb-40"/>
    </>
  );
};

export default FailedOption;
